import { CornerDownRight } from 'lucide-react'
import { StageFunnel } from '../../../boardui/StageFunnel'
import { ChangeIndicator } from './ChangeIndicator'
import { connectorFor, funnelFillWidth, funnelMax, funnelSlots, previousTotal } from './funnel'

// Keep the domain model and ordered step contract here. BoardUI's presentation
// receives already-resolved rates and widths, so it cannot infer a conversion
// across the Feed funnel's Mixpanel/WI identity boundaries.
export function FunnelChain({ steps, label }) {
  const max = funnelMax(steps)
  const rows = steps.map((step, index) => {
    const connector = connectorFor(step, previousTotal(steps, index))
    return {
      ...step,
      width: step.kind === 'total' ? funnelFillWidth(step.count, max) : undefined,
      connector: connector ? { ...connector, icon: <CornerDownRight aria-hidden="true" /> } : null,
      change: step.change ? <ChangeIndicator change={step.change} size={12} text={step.change.short} title={step.change.label} /> : null,
      changeDirection: step.change?.direction,
      changeTitle: step.change?.label,
    }
  })
  return <StageFunnel rows={rows} label={label} slots={funnelSlots(steps)} stackedSlots={funnelSlots(steps, { stacked: true })} />
}
